import { render } from "./Dashboard.vue?vue&type=template&id=20017df0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "@/assets/css/portal.css?vue&type=style&index=0&id=20017df0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20017df0"]])

export default __exports__